/* Accordion.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _24 = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const _23 = "._1yt4192h{padding:var(--_170nn8b)}";
const _22 = "._19pkze3t{margin-top:var(--ds-space-0,0)}";
const _21 = "._1yt41uct{padding:var(--_jkr67p)}";
const _20 = "._19bvxy5q{padding-left:var(--ds-space-400,2pc)}";
const _19 = "._jhb6idpf._jhb6idpf._jhb6idpf span{margin-left:0}";
const _18 = "._15s31wug._15s31wug._15s31wug{height:auto}";
const _17 = "._uqpc1e5h._uqpc1e5h._uqpc1e5h{text-align:left}";
const _16 = "._5jotnqa1._5jotnqa1._5jotnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _15 = "._3rnyglyw._3rnyglyw._3rnyglyw:hover{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _14 = "._3lww18uv._3lww18uv._3lww18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _13 = "._1byqgrf3._1byqgrf3._1byqgrf3{padding-left:0!important}";
const _12 = "._vktqgrf3._vktqgrf3._vktqgrf3{padding-bottom:0!important}";
const _11 = "._1pnsgrf3._1pnsgrf3._1pnsgrf3{padding-right:0!important}";
const _10 = "._1695grf3._1695grf3._1695grf3{padding-top:0!important}";
const _9 = "._4cvr1h6o{align-items:center}";
const _8 = "._80omtlke{cursor:pointer}";
const _7 = "._1e0c1txw{display:flex}";
const _6 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button/standard-button';
import ChevronDownIcon from '@atlaskit/icon/utility/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/utility/chevron-right';
import React, { useState } from 'react';
import { BodyNormal } from '../Typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "._3fcw1wug{text-wrap:auto}";
const _4 = "._18u0idpf{margin-left:0}";
const _3 = "._otyridpf{margin-bottom:0}";
const _2 = "._2hwxidpf{margin-right:0}";
const _ = "._19pkidpf{margin-top:0}";
const Text = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _3fcw1wug", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Text.displayName = 'Text';
}
const LabelWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpu2gc _1e0c1txw _80omtlke _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LabelWrapper.displayName = 'LabelWrapper';
}
const lessSpacingStyle = null;
const moreSpacingStyle = null;
const ButtonWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = Button,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _11, _12, _13, _14, _15, _16, _17, _18, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1695grf3 _1pnsgrf3 _vktqgrf3 _1byqgrf3 _3lww18uv _3rnyglyw _5jotnqa1 _uqpc1e5h _15s31wug _jhb6idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ButtonWrapper.displayName = 'ButtonWrapper';
}
const ChildrenWrapper = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19bvxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ChildrenWrapper.displayName = 'ChildrenWrapper';
}
const Accordion = _ref5 => {
  let {
    title,
    children,
    testId,
    lessSpacing
  } = _ref5;
  const [isOpen, setIsOpen] = useState(false);
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": testId,
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_21, _22, _23, _24]
      }), /*#__PURE__*/_jsxs(LabelWrapper, {
        onClick: toggleAccordion,
        "data-testId": "accordion-toggle",
        className: ax([lessSpacing ? "_1yt41uct _19pkze3t" : "_1yt4192h _19pk1b66"]),
        style: {
          "--_jkr67p": ix("var(--ds-space-025, 2px)".concat(" 0")),
          "--_170nn8b": ix("var(--ds-space-050, 4px)".concat(" 0"))
        },
        children: [isOpen ? /*#__PURE__*/_jsx(ChevronDownIcon, {
          label: ""
        }) : /*#__PURE__*/_jsx(ChevronRightIcon, {
          label: ""
        }), /*#__PURE__*/_jsx(ButtonWrapper, {
          appearance: "link",
          tabIndex: 0,
          children: /*#__PURE__*/_jsx(Text, {
            "data-testId": "accordion-title",
            children: title
          })
        })]
      })]
    }), isOpen && /*#__PURE__*/_jsx(ChildrenWrapper, {
      children: children
    })]
  });
};
export { Accordion };